import jStat from 'jstat';

export interface ZScoreResult {
  input: {
    value: number;
    zScore: number;
    percentile: number;
  };
  stats: {
    mean: number;
    standardDeviation: number;
  };
  data: number[];
  interpretation: string;
}

export function calculateZScores(data: number[], inputValue: number): ZScoreResult {
  const sortedData = [...data].sort((a, b) => a - b);
  const mean = jStat.mean(data);
  const stdDev = jStat.stdev(data, true); // Using population std dev

  const zScore = (inputValue - mean) / stdDev;
  const percentile = jStat.normal.cdf(zScore, 0, 1) * 100;

  let interpretation = `A value of ${inputValue.toFixed(2)} `;
  interpretation += `has a z-score of ${zScore.toFixed(2)}, `;
  interpretation += `which means it is ${Math.abs(zScore).toFixed(2)} standard deviations `;
  interpretation += zScore >= 0 ? 'above' : 'below';
  interpretation += ` the mean (${mean.toFixed(2)}). `;
  interpretation += `This value is at the ${percentile.toFixed(1)}th percentile of a normal distribution.`;

  return {
    input: {
      value: inputValue,
      zScore,
      percentile
    },
    stats: {
      mean,
      standardDeviation: stdDev
    },
    data: sortedData,
    interpretation
  };
} 